import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { useLanguage } from "./context/LanguageContext";
import SubcategoryFetcher from "./components/SubcategoryFetcher";
import { apiClient } from "./services/apiClient";

export default function App() {
  if (process.env.NODE_ENV === "production") {
    console.error = () => {};
    console.warn = () => {};
    console.log = () => {};
  }

  const [value, setValue] = useState(null);
  const [categories, setCategories] = useState([]);
  const { languageId } = useLanguage();

  const fetchCategories = async () => {
    try {
      const categoryData = await apiClient.get("/categorylanguage/", {
        params: {
          category__firm: 3,
          language: languageId,
          is_active: true,
        },
      });
      setCategories(categoryData);

      // Set default selected category if it is not set already
      if (categoryData.length > 0 && value === null) {
        const defaultCategory = categoryData.find(
          (category) => category.category === 6
        );
        if (defaultCategory) {
          setValue(defaultCategory.category);
        }
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    if (!languageId) return;
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageId]); // This runs whenever languageId changes

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "black",
        color: "#000",
      }}
    >
      <Header />
      {categories.length > 0 && value !== null ? (
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          sx={{
            ".MuiTabs-indicator": {
              backgroundColor: "#f5eb16",
            },
          }}
        >
          {categories.map((category) => (
            <Tab
              key={category.id}
              value={category.category}
              label={category.name}
              sx={{
                color: "gray",
                "&.Mui-selected": {
                  color: "#f5eb16",
                },
              }}
            />
          ))}
        </Tabs>
      ) : (
        <div>Loading tabs...</div>
      )}

      <Box sx={{ flex: 1, padding: 2 }}>
        {value && <SubcategoryFetcher categoryId={value} />}
      </Box>

      <Footer />
    </Box>
  );
}
